const dom = require('../utils/DOM');

function Menu() {
	this.init();
}

Menu.prototype = {
	init: function() {
		this.$mainMenu = $('#menu-mainmenu');
		this.$menuBtn = $('button.menu-toggle');

		this.$siteHeader = $('.site-header');
		this.$logo = $('.logo-block');
		this.$closeBtn = $('.close-btn');
		this.$content = $('#content');

		this.$menuBtn.on('click', e => {
			e.preventDefault();
			this.$menuBtn.toggleClass('_opened');
			this.$mainMenu.toggleClass('_show');
			this.$siteHeader.toggleClass('show-menu');
			this.$siteHeader.fadeToggle();
			this.$logo.toggleClass('hide-block');
			this.$closeBtn.toggleClass('block');
			this.$content.toggleClass('hide-block');
		});

		this.initItem();
		this.initMobileNav();

		this.$abcMobileBlock = $('.abc-list-mobile-block');
		if (this.$abcMobileBlock.length > 0) {
			this.initAuthorNav();
		}

		dom.$window.on('resize orientationchange', () => {
			if (dom.$window.width() > 767) {
				this.$menuBtn.removeClass('_opened');
				this.$mainMenu.removeClass('_show');
				this.$siteHeader.removeClass('show-menu');
				this.$siteHeader.show();
				this.$logo.removeClass('hide-block');
				this.$closeBtn.removeClass('block');
				this.$content.removeClass('hide-block');
			}
		});
	},
	initMobileNav: function() {
		this.$scrollBlock = $('.mobile-menu-toggle-block');
		this.$magIssuesArchive = $('.magazine-issues-archive');
		this.scroll_top = dom.$window.scrollTop();

		dom.$window.on('scroll', () => {
			const scrollTop = dom.$window.scrollTop();
			if (this.scroll_top < scrollTop && scrollTop >= 0) {
				this.$scrollBlock.addClass('hidemenu');
			} else {
				this.$scrollBlock.removeClass('hidemenu');
			}
			this.scroll_top = scrollTop > 0 ? scrollTop : 0;

			if (this.$magIssuesArchive.length > 0) {
				if (scrollTop > this.$magIssuesArchive.offset().top - 12) {
					this.$magIssuesArchive.addClass('fixed-btn');
				}
				if ($('.issue-body').length > 0) {
					if (scrollTop < $('.issue-body').offset().top) {
						this.$magIssuesArchive.removeClass('fixed-btn');
					}
				} else if (this.$magIssuesArchive.offset().top < 348) {
					this.$magIssuesArchive.removeClass('fixed-btn');
				}
			}
		});
	},
	initItem: function() {
		this.$mainMenuTitle = this.$mainMenu.find('.sub-menu .menu-item p');
		this.$mainMenuTitle.closest('.menu-item').addClass('_title');
	},
	initAuthorNav: function() {
		this.$abcList = $('.abc-list');
		this.$abcListBtn = $('.abc-list-mobile-block .default-btn');
		this.$abcListBtnCloser = $('.abc-list .default-btn');
		this.$abcListLink = this.$abcList.find('.abc-list a');

		this.$abcListBtn.on('click', () => {
			this.$abcList.addClass('mobile-black-block');
			this.$abcMobileBlock.removeClass('block');
			this.$scrollBlock.addClass('hide-block');
		});
		this.$abcListLink.on('click', () => {
			this.$abcList.removeClass('mobile-black-block');
			this.$abcMobileBlock.addClass('block');
			this.$scrollBlock.removeClass('hide-block');
		});
		this.$abcListBtnCloser.on('click', () => {
			this.$abcList.removeClass('mobile-black-block');
			this.$abcMobileBlock.addClass('block');
			this.$scrollBlock.removeClass('hide-block');
		});
	},
};

module.exports = new Menu();
